var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m20 32 13-6-9-6-1 3H10l-5 6h16l-1 3z",
  fill: "#23B40C",
  className: "delivery_svg__ColoredSvgPath",
  fillOpacity: 0.15
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.18 16H14.15l-1.136 7h2.026l.81-5h25.97l-.805 4.828L39 33.91v.59H13.175l.892-5.5h-2.026L11 35.42V45h8.1a5.002 5.002 0 0 0 9.8 0h13.2a5.002 5.002 0 0 0 9.8 0H57V33.709L49.549 22H43.18l1-6zm7.72 27H55v-8H41v1.5H13V43h6.1a5.002 5.002 0 0 1 9.8 0h13.2a5.002 5.002 0 0 1 9.8 0zm-4.457-10h6.735l-5.727-9h-5.616l-1.637 9h3.787l2.201-3.081 1.628 1.162L47.444 33zM24 41a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm23 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-23 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm25-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
  fill: "#A1A1A9"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m2.865 30 6.667-8h12.747l1.186-3.558 11.576 7.717-16.72 7.718L19.612 30H2.865zm4.27-2h15.252l-.707 2.123 9.279-4.282-6.424-4.283L23.72 24H10.468l-3.333 4z",
  fill: "#23B40C",
  className: "delivery_svg__ColoredSvgPath"
})));
export default SvgDelivery;